import AccountsMixin from "./AccountsMixin.vue";
import InitializeFiltersMixin from "@/mixins/InitializeFiltersMixin.vue";
export default {
  name: "BrandPortfolioMixin",
  mixins: [AccountsMixin, InitializeFiltersMixin],
  mounted() {},
  methods: {
    buildPortfolioTargetId(portfolio, suffix) {
      const {
        workspace_id,
        seller_id,
        sales_channel
      } = portfolio ?? {};
      return [workspace_id, seller_id, sales_channel, suffix].map(part => part ?? "").join("_");
    },
    async getFilterValuesForSellersFilter() {
      this.sellers = await this.getOmnyAccountSellers();
      if (this.sellers.length === 0) {
        // this.handleErrorOccured();
        return;
      }
      return this.sellers;
    },
    async getFilterValuesForMarketPlacesFilter() {
      const path = `/dashboard/v2/filters/countries`;
      this.marketplaces = await this.getCountriesBasedOnSellers({
        sellers: this.currentSellerIds
      }, path);
      return this.marketplaces;
    }
  }
};